module.exports = __webpack_public_path__ + "img/aa.2ba50bb4.jpg";